import { ScopeOfPracticeEnum } from '@umss/shared/utils';

export interface FacilityScopeDto {
  id: number;
  facilityId: string; // Guid
  scopeOfPractice: ScopeOfPracticeEnum;
  scopeOfPracticeDisplay: string;
  isActive: boolean;
  createdAt: string; // DateTime as ISO string
}
